<template>
  <v-row>
    <v-col>
      <v-text-field
        label="Rubrik"
        hint="Obligatorisk"
        persistent-hint
        outlined
        v-model="model"
        :rules="[required]"
        :disabled="readonly"
      />
    </v-col>
  </v-row>
</template>

<script>
import { required } from '@/common/validationRules'
import { sync } from 'vuex-pathify'

export default {
  name: 'TibBannerTitleInput',

  props: {
    readonly: Boolean
  },

  data() {
    return { required }
  },

  computed: {
    model: sync('tibBanner/model@title')
  }
}
</script>
